
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterDropGoogle as ObiSensorWaterDropGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-drop-google.js';
 
 
 

 
 export const ObiSensorWaterDropGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-drop-google',
   elementClass: ObiSensorWaterDropGoogleElement,
   events: {
     
   }
  });
 
 